module.exports = __webpack_public_path__ + "static/media/telephone.a8be148c.svg";